import IService from "@api/iService";
import {UserAuthLog, UserDonateLog} from "@interfaces/user/users";

export default class LogsService extends IService {

    async fetchUserAuthLogs() {
        return await this.getAndThrowApi<UserAuthLog[]>('/api/user/logs/auth/');
    }

    async fetchUserDonateLogs() {
        return await this.getAndThrowApi<UserDonateLog[]>('/api/user/payments/logs/');
    }

    async fetchUserLastAuthLog() {
        return await this.getApi<UserAuthLog>('/api/user/logs/auth/last/');
    }
}